import request from '@/utils/request'

const tradeFapiaoAttachmentApi = {
  trade_fapiao_information_attachment_list: '/trade/fapiao_information_attachment/',
  trade_fapiao_information_attachment_create: '/trade/fapiao_information_attachment/',
  trade_fapiao_information_attachment_update: '/trade/fapiao_information_attachment/',
  trade_fapiao_information_attachment_delete: '/trade/fapiao_information_attachment/'
}

/**
 * 列表
 */
export function fapiao_information_attachment_list (parameter) {
  return request({
    url: tradeFapiaoAttachmentApi.trade_fapiao_information_attachment_list,
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    params: parameter
  })
}
/**
 * 添加
 */
export function fapiao_information_attachment_create (parameter) {
  return request({
    url: tradeFapiaoAttachmentApi.trade_fapiao_information_attachment_create,
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 修改
 */
export function fapiao_information_attachment_update (parameter, fapiao_information_attachment_id) {
  return request({
    url: tradeFapiaoAttachmentApi.trade_fapiao_information_attachment_update + fapiao_information_attachment_id + '/',
    method: 'put',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    },
    data: parameter
  })
}
/**
 * 删除
 */
export function fapiao_information_attachment_delete (fapiao_information_attachment_id) {
  return request({
    url: tradeFapiaoAttachmentApi.trade_fapiao_information_attachment_delete + fapiao_information_attachment_id + '/',
    method: 'delete',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}
